// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imageNumber-m__wrapper__1BLgc"};